import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Reinsurance } from './Reinsurance';

export const ReinsuranceMobile: FunctionComponent = () => {
  return (
    <StyledSection className="reinsurance-mobile">
      <Reinsurance />
    </StyledSection>
  );
};

const StyledSection = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  z-index: 1;
  padding-left: 4px;
  padding-right: 4px;

  display: none;
  @media (max-width: 1024px) {
    margin-top: -40px;
    display: block;
  }
  @media (max-width: 650px) {
    margin-top: 4px;
  }
`;
